import { useQuery, useMutation, queryCache } from 'react-query'
import { OrganizationRepository } from 'repository/organization'
import { Organization, OrganizationSettingsParams } from 'models/organization'
import { LegalDocument, LegalDocumentParams } from 'models/legal-document'

export const useFetchOrganization = () => {
  const { status, data: organization, error } = useQuery(
    'organization',
    OrganizationRepository.fetch,
  )

  return { status, organization, error }
}

export const useUpdateOrganization = () => {
  return useMutation((data: OrganizationSettingsParams) => OrganizationRepository.update(data), {
    onSuccess: (organization: Organization) => {
      queryCache.setQueryData('organization', organization)
    },
  })
}

export const useFetchLegalDocuments = () => {
  const { status, data: legalDocuments, error } = useQuery(
    'legal-documents',
    OrganizationRepository.fetchLegalDocuments,
  )

  return { status, legalDocuments, error }
}

export const useFetchLegalDocument = (documentId: string) => {
  const { status, legalDocuments, error } = useFetchLegalDocuments()

  const legalDocument = legalDocuments?.find((document) => document.id === parseInt(documentId))

  return {
    status,
    legalDocument,
    error,
  }
}

export const useUploadLegalDocument = (id: string) => {
  return useMutation(
    (data: LegalDocumentParams) => OrganizationRepository.uploadLegalDocument(id, data),
    {
      onSuccess: (legalDocument: LegalDocument) => {
        queryCache.setQueryData('legal-documents', (legalDocuments: LegalDocument[] = []) =>
          legalDocuments.map((oldLegalDocument) =>
            oldLegalDocument.id === legalDocument.id ? legalDocument : oldLegalDocument,
          ),
        )
      },
    },
  )
}

export const useFetchInvoices = () => {
  const { status, data: invoices, error } = useQuery("invoices", () => OrganizationRepository.fetchInvoices())
  return { status, invoices, error }
}

export const useFetchPreviousPredictiveReports = () => {
  const { status, data: previousPredictiveReports, error } = useQuery("previousPredictiveReports", () => OrganizationRepository.fetchPreviousPredictiveReports())
  return { status, previousPredictiveReports, error }
}